import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';


import HomeDouble from './views/Home.vue';
import Status from './views/Status.vue';
import E404 from './views/E404.vue';
import Success from './views/Success.vue';

import Wholesale from './components/Wholesale.vue';
import Consumer from './components/Consumer.vue';


import OrderReport from './components/orders/OrderReport';
import OrderProdReview from './components/orders/OrderProdReview';

//create order
import CustomerDetails from './components/orders/CreateOrder';
import chooseLocation from './components/orders/OrderPreview';
import OrderPreview from './components/orders/OrderPreview';
import OrderPreviewRead from './components/orders/OrderPreviewRead';
import _ from "lodash";

const ActionsOrder = () => import('./components/orders/ActionsOrder');

const BulkEdit = () => import('./components/orders/BulkEdit');

import DemoWizard from "@/views/pages/demo-wizard/Index";

Vue.use(Router);

const routes = [
  {
    path: '*',
    component: E404,
  },
  {
    path: '/',
    name: 'home',
    component: DemoWizard,
  },

  {
    path: '/customer-details',
    name: 'customer-details',
    component: CustomerDetails,
  },
  {
    path: '/select-location',
    name: 'chooseLocation',
    component: chooseLocation,
  },
  {
    path: '/order-bulk-edit/:orderId',
    name: 'order-bulk-edit',
    component: BulkEdit,
  },
  {
    path: '/order-actions',
    name: 'order-actions',
    component: ActionsOrder,
  },
  {
    path: '/order-read/:id',
    name: 'order-read',
    component: OrderPreviewRead,
  },
  {
    path: '/order-preview/:id',
    name: 'order-preview',
    component: OrderPreview,
  },
  {
      path: '/prod-review/:id',
      name: 'prod-review',
      component: OrderProdReview,
  },
  {
      path: '/order-report/:id',
      name: 'order-report',
      component: OrderReport,
  },
];

export default new Router({
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
  routes,
  mode: 'history',
  base: process.env.BASE_URL,
});
